import { create } from "sheetly";
export let text = "fancy-dialog::part(modal-root){width:80vw;max-width:400px;min-height:540px}table{width:100%}table{display:block;overflow-x:auto}table td,table th{padding:.25em;border-collapse:collapse;border:1px solid var(--bs-border-color)}td:not(:first-child),th:not(:first-child){cursor:pointer}";
export const sheet = create(text, import.meta.url);
